export default "/images/twitter-footer.png?6d8cebb5d4311d66e59b4bbc7d97a405";